import { getISODate } from "../../helpers";
import { parseOrderedTeamNames } from "./parseOrderedTeamNames";
import { parseAdditionalScores } from "./parseAdditionalScores";
import { parseLiveGameState } from "./parseLiveGameState";
export const parseSportEvent = (event, timezone) => {
    const orderedTeamNames = parseOrderedTeamNames(event.isTeamSwap, event.participants);
    return {
        sportId: event.sportId,
        leagueName: event.leagueName,
        team1Name: orderedTeamNames.team1Name,
        team2Name: orderedTeamNames.team2Name,
        startEventDate: getISODate(event.startEventDate, timezone),
        scores: parseAdditionalScores(event.score),
        isLive: event.isLive,
        liveGameState: parseLiveGameState(event.liveGameState),
        isTeamSwap: event.isTeamSwap,
        tennisMatchType: event.metadata.tennisMatchType,
        numberOfParts: event.metadata.numberOfParts,
        tennisSurface: event.metadata.tennisSurface
    };
};
//# sourceMappingURL=parseSportEvent.js.map